import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndpoint';
import { map } from 'rxjs/operators';


interface Student {
  id: number;
  fullname: string;
  vmsId: string;
  course: string;
  groupName: string;
  date: string;
}

interface Attendance {
  fullname: string;
  vmsId: string;
  date: string;
  course: string;
  groupName: string;
  imageName: string; 
}

@Injectable({
  providedIn: 'root'
})
export class CtvetserviceService {

  constructor(private http: HttpClient, private urlSignature: UrlSignature) {}

  viewAllStudents(): Observable<Student[]> {
    return this.http.get<Student[]>(this.urlSignature.ctvetAllStudents);
  }

  submitCtvetAttendance(data: any, imageFile: File): Observable<any> {
    const formData: FormData = new FormData();
  
    formData.append('fullname', data.fullname);
    formData.append('vmsId', data.vmsId);
    formData.append('date', data.date);
    formData.append('course', data.course);
    formData.append('group', data.group);
    formData.append('status', data.status);
    formData.append('imageName', imageFile); 
  
    return this.http.post(`${this.urlSignature.ctvetStudentSaveAttendance}`, formData);
  }

 
  viewAllAttendance(): Observable<any> {
    return this.http.get<any[]>(this.urlSignature.ctvetallStudentAttendance).pipe(
        map((attendanceList) => {
            // Sort the attendance list by date
            attendanceList.sort((a, b) => {
                const dateA = new Date(a.date); 
                const dateB = new Date(b.date); 
                // Sort in descending order (today's date on top)
                return dateB.getTime() - dateA.getTime();
            });

            // Map the attendance list to include the encoded image URL
            return attendanceList.map(attendance => {
                const encodedImageName = encodeURIComponent(attendance.imageName);
                const imageUrl = `${this.urlSignature}/ctvet/images/${encodedImageName}`;
                console.log('Constructed Image URL:', imageUrl); // Debug log
                
                return {
                    ...attendance,
                    imageUrl: imageUrl
                };
            });
        })
    );
}

  
}
